import type { Hotspot, HotspotDirection } from "../manifest/schema.js";

type Rect = { x: number; y: number; w: number; h: number };

/**
 * Default arrow direction for a navigate hotspot that has no explicit `direction`, from where its rect sits on the
 * still: low on the screen -> `back` (out of the scene, towards the camera), left third -> `left`, right third ->
 * `right`, anything else -> `forward` (into the scene).
 */
export function inferDirection(rect: Rect): HotspotDirection {
  const cx = rect.x + rect.w / 2;
  const cy = rect.y + rect.h / 2;
  if (cy >= 72) return "back";
  if (cx < 33) return "left";
  if (cx > 67) return "right";
  return "forward";
}

/** The direction an arrow hotspot should point: explicit `direction`, otherwise inferred from its rect. */
export function hotspotDirection(h: Extract<Hotspot, { kind: "navigate" }>): HotspotDirection {
  return h.direction ?? inferDirection(h.rect);
}
